module.exports = __webpack_public_path__ + "flyer_background_fire_123-44a7493642ad248702ca2988b3aff8bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_fire_123.jpg
// module id = 1643
// module chunks = 1